import React, { useState, useEffect } from "react";
import axios from "axios";
// Import all required social icons from the FontAwesome (fa) set
import { 
  FaFacebook, 
  FaTwitter, 
  FaPinterest, 
  FaBehance, 
  FaLinkedin, 
  FaDribbble, 
  FaGithub 
} from "react-icons/fa";

function Socialicons(props) {
  const [socialLinks, setSocialLinks] = useState({});

  useEffect(() => {
    axios.get("/api/information").then((response) => {
      setSocialLinks(response.data.socialLinks);
    });
  }, []);

  return (
    <ul
      className={
        props.bordered ? "mi-socialicons mi-socialicons-bordered" : "mi-socialicons"
      }
    >
      {!socialLinks.facebook ? null : (
        <li>
          <a rel="noopener noreferrer" target="_blank" href={socialLinks.facebook}>
            <FaFacebook />
          </a>
        </li>
      )}
      {!socialLinks.twitter ? null : (
        <li>
          <a rel="noopener noreferrer" target="_blank" href={socialLinks.twitter}>
            <FaTwitter />
          </a>
        </li>
      )}
      {!socialLinks.pinterest ? null : (
        <li>
          <a rel="noopener noreferrer" target="_blank" href={socialLinks.pinterest}>
            <FaPinterest />
          </a>
        </li>
      )}
      {!socialLinks.behance ? null : (
        <li>
          <a rel="noopener noreferrer" target="_blank" href={socialLinks.behance}>
            <FaBehance />
          </a>
        </li>
      )}
      {!socialLinks.linkedin ? null : (
        <li>
          <a rel="noopener noreferrer" target="_blank" href={socialLinks.linkedin}>
            <FaLinkedin />
          </a>
        </li>
      )}
      {!socialLinks.dribbble ? null : (
        <li>
          <a rel="noopener noreferrer" target="_blank" href={socialLinks.dribbble}>
            <FaDribbble />
          </a>
        </li>
      )}
      {!socialLinks.github ? null : (
        <li>
          <a rel="noopener noreferrer" target="_blank" href={socialLinks.github}>
            <FaGithub />
          </a>
        </li>
      )}
    </ul>
  );
}

export default Socialicons;